import type { ColorItem, ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useSelector } from 'react-redux'

import { BASE_COLOR_CLOUDY, COLOR_BLUE } from '@/constants/constants'
import type { AppState } from '@/types'

export interface TagOption {
  checked: boolean
  // hex
  color: string
  // pages with the tag
  count: number
  id: ID
  title: string
}

// The same lookup as getProjectColorHexOrDefault, over a list picked once:
// a selector returning a closure would read as changed on every dispatch.
const hexOf = (colors: ColorItem[], colorId: ID) =>
  [...colors, BASE_COLOR_CLOUDY].find((color) => color.id === colorId)
    ?.hexCode ?? COLOR_BLUE

export const useTagOptions = (): TagOption[] => {
  const tags = useSelector(migrationProjectSelector.getProjectTags)

  const selected = useSelector<AppState, ID[]>(
    ({ canvas }) => canvas.tags.selectedTags
  )

  // the raw slice: getProjectColors maps into a fresh array on every call
  const colors = useSelector<AppState, ColorItem[]>(
    ({ manager }) => manager.project.colors
  )

  return tags.map(({ colorId, id, nodes, title }) => ({
    checked: selected.includes(id),
    color: hexOf(colors, colorId),
    count: nodes.length,
    id,
    title,
  }))
}
